var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowForward = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-arrow-forward",
    "data-name": "Icon material-arrow-forward",
    d: "M10.415,6l-.808.793,3.2,3.144H-3v1.125H12.805l-3.2,3.144.808.793L15,10.5Z",
    transform: "translate(3 -6)",
    fill: "#1e1e1e"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-forward.0744a88b.svg";
export { ForwardRef as ReactComponent };